/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ctiproviderhuburlclientid5Inputs */

const en_entity_ctiproviderhuburlclientid5 = /** @type {(inputs: Entity_Ctiproviderhuburlclientid5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI Provider Hub Client ID`)
};

const de_entity_ctiproviderhuburlclientid5 = /** @type {(inputs: Entity_Ctiproviderhuburlclientid5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CTI Provider Hub Client ID`)
};

/**
* | output |
* | --- |
* | "CTI Provider Hub Client ID" |
*
* @param {Entity_Ctiproviderhuburlclientid5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ctiproviderhuburlclientid5 = /** @type {((inputs?: Entity_Ctiproviderhuburlclientid5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ctiproviderhuburlclientid5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ctiproviderhuburlclientid5(inputs)
	return de_entity_ctiproviderhuburlclientid5(inputs)
});
export { entity_ctiproviderhuburlclientid5 as "entity_ctiProviderHubUrlClientId" }